export const CommonErrorCode = {
  ValidationFailed: 'ValidationFailed',
  InternalError: 'InternalError',
  NotFound: 'NotFound',
  ServiceUnavailable: 'ServiceUnavailable',
} as const
export type CommonErrorCode = (typeof CommonErrorCode)[keyof typeof CommonErrorCode]
